import * as Styles from './TechStackBadge.styles';

export type TechStackBadgeProps = {
  title: string;
};

const TechStackBadge = ({ title, ...props }: TechStackBadgeProps): JSX.Element => (
  <Styles.Container {...props}>
    <Styles.Text>{title}</Styles.Text>
  </Styles.Container>
);

export default TechStackBadge;
